import domain from "./domain";

// Resets workspace members state
export const resetWorkspaceMembers = domain.createEvent('resetWorkspaceMembers');
